import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import Accordion, { AccordionItem } from '../components/ui/Accordion';
import { BookOpenIcon, ClipboardCheckIcon, UsersIcon, CalendarIcon, AwardIcon, BeakerIcon, PenToolIcon, LanguagesIcon, CalculatorIcon, GlobeIcon, MusicIcon, ActivityIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const Academics = () => {
  return <div className="min-h-screen bg-white" data-id="element-963">
      <PageHeader title="Academics" description="Discover our comprehensive curriculum, dedicated teaching staff, and approach to academic excellence at Isonyin Grammar School." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/xwrtKazFgq7H6urQHRmWav/WhatsApp_Image_2025-10-24_at_10.01.12_%281%29.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Academics',
      path: '/academics'
    }]} data-id="element-964" />
      <div className="container mx-auto px-4 py-12" data-id="element-965">
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-966">
          <div className="text-center mb-10" data-id="element-967">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-968">
              Academic Excellence
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-969"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-970">
              At Isonyin Grammar School, we are committed to providing a
              rigorous and comprehensive education that prepares students for
              future success.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-971">
            <div data-id="element-972">
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-973">
                Our academic program is designed to challenge students
                intellectually while fostering critical thinking, creativity,
                and a love for learning. We believe in a holistic approach to
                education that develops not only academic knowledge but also
                character, leadership skills, and social responsibility.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-974">
                With a curriculum that meets and exceeds national standards, our
                students are well-prepared for higher education and future
                careers. Our experienced teachers employ diverse teaching
                methods to accommodate different learning styles and ensure that
                each student reaches their full potential.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-975">
                Beyond the classroom, we offer numerous opportunities for
                academic enrichment through clubs, competitions, and special
                programs that allow students to explore their interests and
                develop specialized skills.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-976">
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-977">
                <div className="flex items-center mb-3" data-id="element-978">
                  <BookOpenIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-979" />
                  <h3 className="font-bold text-blue-900" data-id="element-980">
                    Comprehensive Curriculum
                  </h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-981">
                  Balanced academic program covering core subjects and electives
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-982">
                <div className="flex items-center mb-3" data-id="element-983">
                  <ClipboardCheckIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-984" />
                  <h3 className="font-bold text-blue-900" data-id="element-985">
                    Rigorous Assessment
                  </h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-986">
                  Regular evaluation to track progress and identify areas for
                  growth
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-987">
                <div className="flex items-center mb-3" data-id="element-988">
                  <UsersIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-989" />
                  <h3 className="font-bold text-blue-900" data-id="element-990">
                    Qualified Teachers
                  </h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-991">
                  Experienced educators dedicated to student success
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg hover:shadow-md transition-shadow" data-id="element-992">
                <div className="flex items-center mb-3" data-id="element-993">
                  <AwardIcon className="h-6 w-6 text-blue-700 mr-2" data-id="element-994" />
                  <h3 className="font-bold text-blue-900" data-id="element-995">Proven Results</h3>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-996">
                  Consistently high performance in national examinations
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Curriculum Section */}
        <section className="mb-16" id="curriculum" data-id="element-997">
          <div className="text-center mb-10" data-id="element-998">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-999">
              Our Curriculum
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1000"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1001">
              Our comprehensive curriculum is designed to provide a strong
              foundation in core subjects while offering opportunities for
              specialization and exploration.
            </p>
          </div>
          <div className="mb-12" data-id="element-1002">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1003">
              <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-1004">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3uhcY5Mx6ch6FMKTi9n6s3/WhatsApp_Image_2025-10-24_at_10.01.12.jpg" alt="School assembly hall with student desks" className="w-full h-auto" data-id="element-1005" />
                <div className="p-4 bg-white" data-id="element-1006">
                  <h3 className="font-bold text-blue-900 mb-2" data-id="element-1007">
                    Spacious Learning Spaces
                  </h3>
                  <p className="text-gray-700 text-sm" data-id="element-1008">
                    Our large assembly hall doubles as an examination center,
                    accommodating hundreds of students comfortably
                  </p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-1009">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ez9ThFy3DkQ6XwMpYtSRNQ/WhatsApp_Image_2025-10-24_at_10.01.16.jpg" alt="Modern science laboratory with students" className="w-full h-auto" data-id="element-1010" />
                <div className="p-4 bg-white" data-id="element-1011">
                  <h3 className="font-bold text-blue-900 mb-2" data-id="element-1012">
                    State-of-the-Art Laboratories
                  </h3>
                  <p className="text-gray-700 text-sm" data-id="element-1013">
                    Modern science laboratories equipped with the latest
                    equipment for hands-on learning
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1014">
            <div className="lg:col-span-2" data-id="element-1015">
              <h3 className="text-2xl font-bold text-blue-900 mb-6" data-id="element-1016">
                Academic Structure
              </h3>
              <Accordion className="mb-8" variant="bordered" data-id="element-1017">
                <AccordionItem title="Junior Secondary School (JSS 1-3)" defaultOpen data-id="element-1018">
                  <p className="text-gray-700 mb-4" data-id="element-1019">
                    The Junior Secondary curriculum provides a broad foundation
                    across various subject areas. Students study:
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-1020">
                    <div className="flex items-start" data-id="element-1021">
                      <LanguagesIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-1022" />
                      <div data-id="element-1023">
                        <p className="font-bold" data-id="element-1024">Languages</p>
                        <p className="text-sm text-gray-600" data-id="element-1025">
                          English, Yoruba, French
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1026">
                      <CalculatorIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-1027" />
                      <div data-id="element-1028">
                        <p className="font-bold" data-id="element-1029">Mathematics</p>
                        <p className="text-sm text-gray-600" data-id="element-1030">
                          Basic Mathematics
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1031">
                      <BeakerIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-1032" />
                      <div data-id="element-1033">
                        <p className="font-bold" data-id="element-1034">Sciences</p>
                        <p className="text-sm text-gray-600" data-id="element-1035">
                          Integrated Science, Agricultural Science, Basic
                          Technology
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1036">
                      <GlobeIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-1037" />
                      <div data-id="element-1038">
                        <p className="font-bold" data-id="element-1039">Social Studies</p>
                        <p className="text-sm text-gray-600" data-id="element-1040">
                          Social Studies, Civic Education, Religious Studies
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1041">
                      <PenToolIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-1042" />
                      <div data-id="element-1043">
                        <p className="font-bold" data-id="element-1044">Creative Arts</p>
                        <p className="text-sm text-gray-600" data-id="element-1045">
                          Fine Arts, Music, Home Economics
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-1046">
                      <ActivityIcon className="h-5 w-5 text-blue-700 mr-2 mt-0.5" data-id="element-1047" />
                      <div data-id="element-1048">
                        <p className="font-bold" data-id="element-1049">Physical Education</p>
                        <p className="text-sm text-gray-600" data-id="element-1050">
                          Physical & Health Education
                        </p>
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-700" data-id="element-1051">
                    At the end of JSS 3, students take the Junior School
                    Certificate Examination (JSCE) which qualifies them for
                    Senior Secondary education.
                  </p>
                </AccordionItem>
                <AccordionItem title="Senior Secondary School (SSS 1-3)" data-id="element-1052">
                  <p className="text-gray-700 mb-4" data-id="element-1053">
                    In Senior Secondary, students begin to specialize while
                    maintaining core subjects. They choose one of three tracks:
                  </p>
                  <div className="space-y-6 mb-4" data-id="element-1054">
                    <div className="bg-blue-50 p-4 rounded-lg" data-id="element-1055">
                      <h4 className="font-bold text-blue-900 mb-2" data-id="element-1056">
                        Science Track
                      </h4>
                      <p className="text-gray-700 mb-2" data-id="element-1057">Core subjects:</p>
                      <ul className="grid grid-cols-2 gap-2 text-sm text-gray-700" data-id="element-1058">
                        <li className="flex items-center" data-id="element-1059">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1060"></div>
                          <span data-id="element-1061">English Language</span>
                        </li>
                        <li className="flex items-center" data-id="element-1062">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1063"></div>
                          <span data-id="element-1064">Mathematics</span>
                        </li>
                        <li className="flex items-center" data-id="element-1065">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1066"></div>
                          <span data-id="element-1067">Physics</span>
                        </li>
                        <li className="flex items-center" data-id="element-1068">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1069"></div>
                          <span data-id="element-1070">Chemistry</span>
                        </li>
                        <li className="flex items-center" data-id="element-1071">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1072"></div>
                          <span data-id="element-1073">Biology</span>
                        </li>
                        <li className="flex items-center" data-id="element-1074">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1075"></div>
                          <span data-id="element-1076">Civic Education</span>
                        </li>
                      </ul>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg" data-id="element-1077">
                      <h4 className="font-bold text-blue-900 mb-2" data-id="element-1078">
                        Commercial Track
                      </h4>
                      <p className="text-gray-700 mb-2" data-id="element-1079">Core subjects:</p>
                      <ul className="grid grid-cols-2 gap-2 text-sm text-gray-700" data-id="element-1080">
                        <li className="flex items-center" data-id="element-1081">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1082"></div>
                          <span data-id="element-1083">English Language</span>
                        </li>
                        <li className="flex items-center" data-id="element-1084">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1085"></div>
                          <span data-id="element-1086">Mathematics</span>
                        </li>
                        <li className="flex items-center" data-id="element-1087">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1088"></div>
                          <span data-id="element-1089">Economics</span>
                        </li>
                        <li className="flex items-center" data-id="element-1090">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1091"></div>
                          <span data-id="element-1092">Commerce</span>
                        </li>
                        <li className="flex items-center" data-id="element-1093">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1094"></div>
                          <span data-id="element-1095">Accounting</span>
                        </li>
                        <li className="flex items-center" data-id="element-1096">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1097"></div>
                          <span data-id="element-1098">Civic Education</span>
                        </li>
                      </ul>
                    </div>
                    <div className="bg-blue-50 p-4 rounded-lg" data-id="element-1099">
                      <h4 className="font-bold text-blue-900 mb-2" data-id="element-1100">
                        Arts Track
                      </h4>
                      <p className="text-gray-700 mb-2" data-id="element-1101">Core subjects:</p>
                      <ul className="grid grid-cols-2 gap-2 text-sm text-gray-700" data-id="element-1102">
                        <li className="flex items-center" data-id="element-1103">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1104"></div>
                          <span data-id="element-1105">English Language</span>
                        </li>
                        <li className="flex items-center" data-id="element-1106">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1107"></div>
                          <span data-id="element-1108">Mathematics</span>
                        </li>
                        <li className="flex items-center" data-id="element-1109">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1110"></div>
                          <span data-id="element-1111">Literature in English</span>
                        </li>
                        <li className="flex items-center" data-id="element-1112">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1113"></div>
                          <span data-id="element-1114">Government</span>
                        </li>
                        <li className="flex items-center" data-id="element-1115">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1116"></div>
                          <span data-id="element-1117">History</span>
                        </li>
                        <li className="flex items-center" data-id="element-1118">
                          <div className="h-1.5 w-1.5 bg-blue-700 rounded-full mr-2" data-id="element-1119"></div>
                          <span data-id="element-1120">Civic Education</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p className="text-gray-700" data-id="element-1121">
                    Students also select additional elective subjects based on
                    their track and interests. At the end of SSS 3, students
                    take the West African Senior School Certificate Examination
                    (WASSCE) and the National Examination Council (NECO)
                    examinations.
                  </p>
                </AccordionItem>
              </Accordion>
              <div className="bg-blue-900 text-white p-6 rounded-lg mb-6" data-id="element-1122">
                <h3 className="text-xl font-bold mb-4" data-id="element-1123">Teaching Methodology</h3>
                <p className="mb-4" data-id="element-1124">
                  Our teaching approach combines traditional and modern
                  methodologies to ensure effective learning:
                </p>
                <ul className="space-y-3" data-id="element-1125">
                  <li className="flex items-start" data-id="element-1126">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-1127">✓</div>
                    <p data-id="element-1128">
                      Interactive classroom discussions that encourage critical
                      thinking
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-1129">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-1130">✓</div>
                    <p data-id="element-1131">
                      Practical laboratory sessions for hands-on learning in
                      sciences
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-1132">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-1133">✓</div>
                    <p data-id="element-1134">
                      Project-based learning that develops research and
                      collaboration skills
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-1135">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-1136">✓</div>
                    <p data-id="element-1137">
                      Technology integration through our computer labs and
                      digital resources
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-1138">
                    <div className="h-5 w-5 text-yellow-400 mr-2" data-id="element-1139">✓</div>
                    <p data-id="element-1140">
                      Field trips and guest speakers to connect classroom
                      learning to real-world applications
                    </p>
                  </li>
                </ul>
              </div>
              <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-100" data-id="element-1141">
                <div className="flex items-center mb-4" data-id="element-1142">
                  <BookOpenIcon className="h-6 w-6 text-yellow-600 mr-3" data-id="element-1143" />
                  <h3 className="text-xl font-bold text-blue-900" data-id="element-1144">
                    Special Academic Programs
                  </h3>
                </div>
                <div className="space-y-4" data-id="element-1145">
                  <div data-id="element-1146">
                    <h4 className="font-bold text-blue-900" data-id="element-1147">
                      Advanced Mathematics Program
                    </h4>
                    <p className="text-gray-700 text-sm" data-id="element-1148">
                      Special coaching for mathematically gifted students,
                      preparing them for national and international
                      competitions.
                    </p>
                  </div>
                  <div data-id="element-1149">
                    <h4 className="font-bold text-blue-900" data-id="element-1150">
                      Language Immersion
                    </h4>
                    <p className="text-gray-700 text-sm" data-id="element-1151">
                      Enhanced language learning opportunities in French and
                      Yoruba through cultural activities and exchange programs.
                    </p>
                  </div>
                  <div data-id="element-1152">
                    <h4 className="font-bold text-blue-900" data-id="element-1153">
                      Science Innovation Hub
                    </h4>
                    <p className="text-gray-700 text-sm" data-id="element-1154">
                      An after-school program where students work on science
                      projects and innovations under the guidance of experienced
                      mentors.
                    </p>
                  </div>
                  <div data-id="element-1155">
                    <h4 className="font-bold text-blue-900" data-id="element-1156">
                      Leadership Development
                    </h4>
                    <p className="text-gray-700 text-sm" data-id="element-1157">
                      A structured program to develop leadership skills through
                      workshops, community service, and practical leadership
                      roles.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-1158">
              <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-1159">
                <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-1160">
                  Academic Support
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-1161">
                  We are committed to helping every student succeed
                  academically. Our support services include:
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-1162">
                  <li className="flex items-start" data-id="element-1163">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-1164">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1165">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1166" />
                      </svg>
                    </div>
                    <p data-id="element-1167">
                      Tutorial sessions for students needing additional help
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-1168">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-1169">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1170">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1171" />
                      </svg>
                    </div>
                    <p data-id="element-1172">
                      Remedial classes for students who need to strengthen
                      specific skills
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-1173">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-1174">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1175">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1176" />
                      </svg>
                    </div>
                    <p data-id="element-1177">
                      Guidance counseling for academic planning and career
                      guidance
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-1178">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-1179">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1180">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1181" />
                      </svg>
                    </div>
                    <p data-id="element-1182">
                      Study skills workshops to improve learning effectiveness
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-1183">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-1184">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1185">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1186" />
                      </svg>
                    </div>
                    <p data-id="element-1187">
                      Peer tutoring program where high-achieving students help
                      their peers
                    </p>
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-1188">
                <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-1189">
                  Assessment & Reporting
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-1190">
                  Student progress is regularly assessed through:
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-1191">
                  <li className="flex items-start" data-id="element-1192">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-1193">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1194">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1195" />
                      </svg>
                    </div>
                    <p data-id="element-1196">Continuous Assessment Tests (CATs)</p>
                  </li>
                  <li className="flex items-start" data-id="element-1197">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-1198">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1199">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1200" />
                      </svg>
                    </div>
                    <p data-id="element-1201">Mid-term examinations</p>
                  </li>
                  <li className="flex items-start" data-id="element-1202">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-1203">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1204">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1205" />
                      </svg>
                    </div>
                    <p data-id="element-1206">End-of-term examinations</p>
                  </li>
                  <li className="flex items-start" data-id="element-1207">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-1208">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1209">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1210" />
                      </svg>
                    </div>
                    <p data-id="element-1211">Project work and assignments</p>
                  </li>
                  <li className="flex items-start" data-id="element-1212">
                    <div className="h-5 w-5 text-blue-700 mr-2" data-id="element-1213">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-1214">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1215" />
                      </svg>
                    </div>
                    <p data-id="element-1216">Class participation and practical work</p>
                  </li>
                </ul>
                <p className="mt-4 text-gray-700" data-id="element-1217">
                  Comprehensive reports are issued at the end of each term, and
                  parent-teacher meetings are held to discuss student progress.
                </p>
              </div>
              <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white p-6 rounded-lg" data-id="element-1218">
                <h3 className="text-xl font-bold mb-4" data-id="element-1219">Academic Facilities</h3>
                <ul className="space-y-3" data-id="element-1220">
                  <li className="flex items-start" data-id="element-1221">
                    <BeakerIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-1222" />
                    <p data-id="element-1223">Well-equipped science laboratories</p>
                  </li>
                  <li className="flex items-start" data-id="element-1224">
                    <BookOpenIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-1225" />
                    <p data-id="element-1226">Modern library with extensive resources</p>
                  </li>
                  <li className="flex items-start" data-id="element-1227">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1228">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-1229" />
                    </svg>
                    <p data-id="element-1230">Computer labs with internet access</p>
                  </li>
                  <li className="flex items-start" data-id="element-1231">
                    <MusicIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-1232" />
                    <p data-id="element-1233">Music and art studios</p>
                  </li>
                  <li className="flex items-start" data-id="element-1234">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-400 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1235">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" data-id="element-1236" />
                    </svg>
                    <p data-id="element-1237">Dedicated classrooms for each subject</p>
                  </li>
                </ul>
                <div className="mt-6" data-id="element-1238">
                  <Button href="/campus" variant="primary" size="sm" data-id="element-1239">
                    View Campus Facilities
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Science Laboratories Section */}
        <section className="mb-16 bg-gray-50 py-12" data-id="element-1240">
          <div className="container mx-auto px-4" data-id="element-1241">
            <div className="text-center mb-10" data-id="element-1242">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1243">
                Science Laboratories
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1244"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1245">
                Our well-equipped science laboratories provide students with
                hands-on experience in scientific inquiry and experimentation
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-12" data-id="element-1246">
              <div data-id="element-1247">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hWx5tyEVbwQVrxum4dtVj3/WhatsApp_Image_2025-10-24_at_13.20.17_%281%29.jpg" alt="Students in science laboratory" className="w-full rounded-lg shadow-lg" data-id="element-1248" />
              </div>
              <div data-id="element-1249">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-1250">
                  Modern Laboratory Facilities
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1251">
                  Our science laboratories are equipped with modern apparatus
                  and equipment that enable students to conduct experiments
                  safely and effectively. From physics to chemistry to biology,
                  students gain practical experience that reinforces theoretical
                  concepts learned in the classroom.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1252">
                  Under the supervision of qualified science teachers, students
                  develop critical thinking skills, learn the scientific method,
                  and cultivate a passion for scientific discovery. Our
                  laboratories feature proper safety equipment, adequate
                  workspace, and well-organized storage for chemicals and
                  apparatus.
                </p>
                <ul className="space-y-2" data-id="element-1253">
                  <li className="flex items-start" data-id="element-1254">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2 mt-1" data-id="element-1255">
                      <svg className="h-4 w-4 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1256">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-1257" />
                      </svg>
                    </div>
                    <span className="text-gray-700" data-id="element-1258">
                      Physics laboratory with modern equipment
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1259">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2 mt-1" data-id="element-1260">
                      <svg className="h-4 w-4 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1261">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-1262" />
                      </svg>
                    </div>
                    <span className="text-gray-700" data-id="element-1263">
                      Chemistry laboratory with safety features
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1264">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2 mt-1" data-id="element-1265">
                      <svg className="h-4 w-4 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1266">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-1267" />
                      </svg>
                    </div>
                    <span className="text-gray-700" data-id="element-1268">
                      Biology laboratory with microscopes and specimens
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1269">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2 mt-1" data-id="element-1270">
                      <svg className="h-4 w-4 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1271">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-1272" />
                      </svg>
                    </div>
                    <span className="text-gray-700" data-id="element-1273">
                      Qualified science teachers and lab technicians
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* Teaching Excellence Section */}
        <section className="mb-16 bg-gray-50 py-12" data-id="element-1274">
          <div className="container mx-auto px-4" data-id="element-1275">
            <div className="text-center mb-10" data-id="element-1276">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1277">
                Teaching Excellence
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1278"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1279">
                Our dedicated teachers employ modern pedagogical methods to
                ensure effective learning
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-12" data-id="element-1280">
              <div data-id="element-1281">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rYxE1D1a3w1zMFiLJm2aU1/WhatsApp_Image_2025-10-24_at_10.01.17.jpg" alt="Teacher conducting chemistry lesson" className="w-full rounded-lg shadow-lg" data-id="element-1282" />
              </div>
              <div data-id="element-1283">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-1284">
                  Interactive Teaching Methods
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1285">
                  Our teachers use interactive whiteboards and modern teaching
                  aids to make lessons engaging and effective. We employ proven
                  pedagogical methods like PSI/PMI to ensure students grasp
                  concepts thoroughly.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-1286">
                  Every classroom is equipped with teaching materials that
                  support visual, auditory, and kinesthetic learning styles,
                  ensuring that every student can learn effectively.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-12" data-id="element-1287">
              <div className="order-2 md:order-1" data-id="element-1288">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-1289">
                  Technology-Enhanced Learning
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1290">
                  Our teachers integrate technology into their lessons using
                  laptops, projectors, and interactive displays. This modern
                  approach helps students visualize complex concepts in physics,
                  mathematics, and other subjects.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-1291">
                  From wave mechanics to mathematical functions, our teachers
                  use digital tools to make abstract concepts concrete and
                  understandable for students.
                </p>
              </div>
              <div className="order-1 md:order-2" data-id="element-1292">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/26CHK6sEK66nfVUNdvbwf4/WhatsApp_Image_2025-10-24_at_10.01.20_%282%29.jpg" alt="Teacher using technology in physics lesson" className="w-full rounded-lg shadow-lg" data-id="element-1293" />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-12" data-id="element-1294">
              <div data-id="element-1295">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fBcdZe3j5kT56auYSAwRFV/WhatsApp_Image_2025-10-24_at_10.01.23_%281%29.jpg" alt="Female teacher teaching mathematics" className="w-full rounded-lg shadow-lg" data-id="element-1296" />
              </div>
              <div data-id="element-1297">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-1298">
                  Mathematics Excellence
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1299">
                  Our mathematics teachers are experts in their field, teaching
                  advanced topics like differential calculus, circle geometry,
                  and music-mathematics therapy. They use innovative approaches
                  to make mathematics accessible and interesting.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-1300">
                  Students benefit from clear explanations, step-by-step
                  problem-solving techniques, and real-world applications of
                  mathematical concepts.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1301">
              <div className="order-2 md:order-1" data-id="element-1302">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-1303">
                  Biology & Life Sciences
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1304">
                  Our biology teachers bring concepts to life using anatomical
                  models, skeletons, and other teaching aids. Students engage in
                  hands-on learning that makes complex biological concepts easy
                  to understand.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-1305">
                  From human anatomy to supporting tissues in animals, our
                  comprehensive approach ensures students develop a deep
                  understanding of life sciences.
                </p>
              </div>
              <div className="order-1 md:order-2" data-id="element-1306">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kMX4mMRKhHUYMbFhqjEMu9/WhatsApp_Image_2025-10-24_at_10.01.20_%281%29.jpg" alt="Teacher teaching biology with anatomical models" className="w-full rounded-lg shadow-lg" data-id="element-1307" />
              </div>
            </div>
          </div>
        </section>
        {/* Technology Integration Section - Add ICT Room */}
        <section className="mb-16" data-id="element-1308">
          <div className="container mx-auto px-4" data-id="element-1309">
            <div className="text-center mb-10" data-id="element-1310">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1311">
                Technology in Education
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1312"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1313">
                We integrate technology into our curriculum to prepare students
                for the digital age
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-1314">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-1315">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3GFAKQjjuFe5vR4bv8XoiJ/WhatsApp_Image_2025-10-24_at_10.01.21_%281%29.jpg" alt="Students in computer lab" className="w-full h-64 object-cover" data-id="element-1316" />
                <div className="p-6" data-id="element-1317">
                  <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-1318">
                    Computer Laboratory
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-1319">
                    Our modern computer lab is equipped with up-to-date
                    computers where students learn essential digital skills,
                    programming, and computer applications under expert
                    guidance.
                  </p>
                  <p className="text-sm text-gray-600 italic" data-id="element-1320">
                    Preparing students for the digital economy with hands-on
                    technology training
                  </p>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-1321">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tj13uTG1CCX8nkvziVAAab/WhatsApp_Image_2025-10-24_at_10.01.17_%281%29.jpg" alt="ICT Room donated by Old Students Association" className="w-full h-64 object-cover" data-id="element-1322" />
                <div className="p-6" data-id="element-1323">
                  <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-1324">
                    ICT Laboratory
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-1325">
                    Our Information and Communication Technology (ICT) room,
                    generously donated by the Old Students Association 75/80
                    Set, is equipped with modern computers and internet
                    connectivity.
                  </p>
                  <p className="text-sm text-gray-600 italic" data-id="element-1326">
                    A testament to our alumni's commitment to advancing
                    education at IGS
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg" data-id="element-1327">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-1328">
                Digital Literacy Programs
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1329">
                <div data-id="element-1330">
                  <h4 className="font-bold text-blue-900 mb-2" data-id="element-1331">
                    Basic Computing
                  </h4>
                  <p className="text-gray-700 text-sm" data-id="element-1332">
                    Students learn word processing, spreadsheets, presentations,
                    and internet research skills.
                  </p>
                </div>
                <div data-id="element-1333">
                  <h4 className="font-bold text-blue-900 mb-2" data-id="element-1334">Programming</h4>
                  <p className="text-gray-700 text-sm" data-id="element-1335">
                    Introduction to coding and programming languages, preparing
                    students for careers in technology.
                  </p>
                </div>
                <div data-id="element-1336">
                  <h4 className="font-bold text-blue-900 mb-2" data-id="element-1337">
                    Digital Citizenship
                  </h4>
                  <p className="text-gray-700 text-sm" data-id="element-1338">
                    Teaching responsible and ethical use of technology, online
                    safety, and digital etiquette.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Library Section */}
        <section className="mb-16 bg-gray-50 py-12" data-id="element-1339">
          <div className="container mx-auto px-4" data-id="element-1340">
            <div className="text-center mb-10" data-id="element-1341">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1342">
                School Library
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1343"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1344">
                Our well-stocked library provides students with access to a wide
                range of educational resources
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1345">
              <div data-id="element-1346">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tDi3zMHQVzwj3EoB8pBjyc/WhatsApp_Image_2025-10-24_at_10.01.18_%282%29.jpg" alt="School library with bookshelves" className="w-full rounded-lg shadow-lg" data-id="element-1347" />
              </div>
              <div data-id="element-1348">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-1349">
                  Comprehensive Learning Resources
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1350">
                  Our library houses thousands of books across all subject
                  areas, from mathematics and sciences to literature and social
                  studies. Students have access to reference materials,
                  textbooks, and recreational reading materials.
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-1351">
                  <li className="flex items-start" data-id="element-1352">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-1353">
                      <span className="text-blue-700 text-sm" data-id="element-1354">✓</span>
                    </div>
                    <span data-id="element-1355">Organized by subject areas for easy access</span>
                  </li>
                  <li className="flex items-start" data-id="element-1356">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-1357">
                      <span className="text-blue-700 text-sm" data-id="element-1358">✓</span>
                    </div>
                    <span data-id="element-1359">Quiet study areas for individual learning</span>
                  </li>
                  <li className="flex items-start" data-id="element-1360">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-1361">
                      <span className="text-blue-700 text-sm" data-id="element-1362">✓</span>
                    </div>
                    <span data-id="element-1363">Regularly updated with new titles</span>
                  </li>
                  <li className="flex items-start" data-id="element-1364">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mr-2" data-id="element-1365">
                      <span className="text-blue-700 text-sm" data-id="element-1366">✓</span>
                    </div>
                    <span data-id="element-1367">Supervised by trained library staff</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* Performance Records Section */}
        <section className="mb-16 bg-gray-50 py-12 rounded-lg" id="performance" data-id="element-1368">
          <div className="container mx-auto px-4" data-id="element-1369">
            <div className="text-center mb-10" data-id="element-1370">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1371">
                Academic Performance
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1372"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1373">
                Our students consistently achieve excellent results in national
                examinations and competitions.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12" data-id="element-1374">
              <div data-id="element-1375">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-1376">
                  Examination Results
                </h3>
                <p className="text-gray-700 mb-6" data-id="element-1377">
                  Isonyin Grammar School has maintained an outstanding record in
                  national examinations over the years. Our students
                  consistently perform above the national average in both the
                  West African Senior School Certificate Examination (WASSCE)
                  and the National Examination Council (NECO) examinations.
                </p>
                <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-1378">
                  <h4 className="font-bold text-blue-900 mb-3" data-id="element-1379">
                    WAEC Results (2022)
                  </h4>
                  <div className="overflow-x-auto" data-id="element-1380">
                    <table className="min-w-full bg-white" data-id="element-1381">
                      <thead data-id="element-1382">
                        <tr className="bg-blue-900 text-white" data-id="element-1383">
                          <th className="py-2 px-4 text-left" data-id="element-1384">Grade</th>
                          <th className="py-2 px-4 text-left" data-id="element-1385">
                            Percentage of Students
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200" data-id="element-1386">
                        <tr data-id="element-1387">
                          <td className="py-2 px-4 font-medium" data-id="element-1388">
                            A1-B3 (Distinction)
                          </td>
                          <td className="py-2 px-4" data-id="element-1389">68%</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1390">
                          <td className="py-2 px-4 font-medium" data-id="element-1391">
                            C4-C6 (Credit)
                          </td>
                          <td className="py-2 px-4" data-id="element-1392">27%</td>
                        </tr>
                        <tr data-id="element-1393">
                          <td className="py-2 px-4 font-medium" data-id="element-1394">
                            D7-E8 (Pass)
                          </td>
                          <td className="py-2 px-4" data-id="element-1395">4%</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1396">
                          <td className="py-2 px-4 font-medium" data-id="element-1397">F9 (Fail)</td>
                          <td className="py-2 px-4" data-id="element-1398">1%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-1399">
                  <h4 className="font-bold text-blue-900 mb-3" data-id="element-1400">
                    5-Year Performance Trend
                  </h4>
                  <p className="text-gray-700 mb-3" data-id="element-1401">
                    Percentage of students with 5 credits and above (including
                    English and Mathematics):
                  </p>
                  <div className="relative h-60" data-id="element-1402">
                    <div className="absolute bottom-0 left-0 w-full h-full flex items-end" data-id="element-1403">
                      <div className="w-1/5 h-[75%] bg-blue-700 mx-1 relative group" data-id="element-1404">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1405">
                          75%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1406">
                          2018
                        </div>
                      </div>
                      <div className="w-1/5 h-[82%] bg-blue-700 mx-1 relative group" data-id="element-1407">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1408">
                          82%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1409">
                          2019
                        </div>
                      </div>
                      <div className="w-1/5 h-[88%] bg-blue-700 mx-1 relative group" data-id="element-1410">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1411">
                          88%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1412">
                          2020
                        </div>
                      </div>
                      <div className="w-1/5 h-[90%] bg-blue-700 mx-1 relative group" data-id="element-1413">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1414">
                          90%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1415">
                          2021
                        </div>
                      </div>
                      <div className="w-1/5 h-[95%] bg-blue-700 mx-1 relative group" data-id="element-1416">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1417">
                          95%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1418">
                          2022
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-1419">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-1420">
                  Academic Achievements
                </h3>
                <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-1421">
                  <h4 className="font-bold text-blue-900 mb-3" data-id="element-1422">
                    National & International Competitions
                  </h4>
                  <ul className="space-y-4" data-id="element-1423">
                    <li className="flex items-start" data-id="element-1424">
                      <AwardIcon className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" data-id="element-1425" />
                      <div data-id="element-1426">
                        <p className="font-bold" data-id="element-1427">
                          National Mathematics Competition
                        </p>
                        <p className="text-sm text-gray-700" data-id="element-1428">
                          1st Place (2022), 2nd Place (2021)
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1429">
                      <AwardIcon className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" data-id="element-1430" />
                      <div data-id="element-1431">
                        <p className="font-bold" data-id="element-1432">National Science Olympiad</p>
                        <p className="text-sm text-gray-700" data-id="element-1433">
                          Top 5 Finalists (2022), Regional Champions (2021,
                          2020)
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1434">
                      <AwardIcon className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" data-id="element-1435" />
                      <div data-id="element-1436">
                        <p className="font-bold" data-id="element-1437">Debate Competition</p>
                        <p className="text-sm text-gray-700" data-id="element-1438">
                          State Champions (2022), National Semi-finalists (2021)
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1439">
                      <AwardIcon className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" data-id="element-1440" />
                      <div data-id="element-1441">
                        <p className="font-bold" data-id="element-1442">Robotics Challenge</p>
                        <p className="text-sm text-gray-700" data-id="element-1443">
                          2nd Place, National Level (2022)
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1444">
                      <AwardIcon className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" data-id="element-1445" />
                      <div data-id="element-1446">
                        <p className="font-bold" data-id="element-1447">Essay Writing Contest</p>
                        <p className="text-sm text-gray-700" data-id="element-1448">
                          National Winner (2021), State Winner (2022)
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-1449">
                  <h4 className="font-bold text-blue-900 mb-3" data-id="element-1450">
                    University Admissions
                  </h4>
                  <p className="text-gray-700 mb-3" data-id="element-1451">
                    Our graduates consistently gain admission to top
                    universities in Nigeria and abroad:
                  </p>
                  <div className="grid grid-cols-2 gap-2 text-sm text-gray-700" data-id="element-1452">
                    <div className="flex items-center" data-id="element-1453">
                      <div className="h-2 w-2 bg-blue-700 rounded-full mr-2" data-id="element-1454"></div>
                      <span data-id="element-1455">University of Lagos</span>
                    </div>
                    <div className="flex items-center" data-id="element-1456">
                      <div className="h-2 w-2 bg-blue-700 rounded-full mr-2" data-id="element-1457"></div>
                      <span data-id="element-1458">University of Ibadan</span>
                    </div>
                    <div className="flex items-center" data-id="element-1459">
                      <div className="h-2 w-2 bg-blue-700 rounded-full mr-2" data-id="element-1460"></div>
                      <span data-id="element-1461">Covenant University</span>
                    </div>
                    <div className="flex items-center" data-id="element-1462">
                      <div className="h-2 w-2 bg-blue-700 rounded-full mr-2" data-id="element-1463"></div>
                      <span data-id="element-1464">Obafemi Awolowo University</span>
                    </div>
                    <div className="flex items-center" data-id="element-1465">
                      <div className="h-2 w-2 bg-blue-700 rounded-full mr-2" data-id="element-1466"></div>
                      <span data-id="element-1467">University of Benin</span>
                    </div>
                    <div className="flex items-center" data-id="element-1468">
                      <div className="h-2 w-2 bg-blue-700 rounded-full mr-2" data-id="element-1469"></div>
                      <span data-id="element-1470">University of Nigeria</span>
                    </div>
                  </div>
                  <p className="mt-3 text-gray-700" data-id="element-1471">
                    International universities our alumni attend include
                    institutions in the UK, US, Canada, and other countries.
                  </p>
                </div>
                <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-100" data-id="element-1472">
                  <div className="flex items-center mb-3" data-id="element-1473">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1474">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-1475" />
                    </svg>
                    <h4 className="font-bold text-blue-900" data-id="element-1476">Success Story</h4>
                  </div>
                  <p className="text-gray-700 italic mb-3" data-id="element-1477">
                    "Our 2022 valedictorian, Oluwaseun Adebayo, scored A1 in all
                    nine subjects in WAEC and was offered scholarships to three
                    international universities. He is currently studying
                    Mechanical Engineering at Imperial College London."
                  </p>
                  <p className="text-right text-sm text-gray-600" data-id="element-1478">
                    — Dr. Oluwasegun Adeyemi, Principal
                  </p>
                </div>
              </div>
            </div>
            <div className="text-center" data-id="element-1479">
              <Button href="/academics/results" variant="primary" className="mx-auto" data-id="element-1480">
                View Detailed Performance Records
              </Button>
            </div>
          </div>
        </section>
        {/* Teaching Staff Section */}
        <section className="py-16 bg-white" id="staff" data-id="element-1481">
          <div className="container mx-auto px-4" data-id="element-1482">
            <div className="text-center mb-10" data-id="element-1483">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1484">
                Our Teaching Staff
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1485"></div>
              <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1486">
                Meet our dedicated educators who are committed to nurturing the
                next generation of leaders.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12" data-id="element-1487">
              <div data-id="element-1488">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-1489">
                  Excellence in Teaching
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1490">
                  Our teaching staff comprises highly qualified and experienced
                  educators who are passionate about their subjects and
                  dedicated to student success. They employ innovative teaching
                  methods, including the PSI/PMI pedagogy, to ensure that every
                  student receives a world-class education.
                </p>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1491">
                  Our teachers undergo continuous professional development to
                  stay current with the latest educational trends and best
                  practices. They work collaboratively to create a supportive
                  learning environment where students can thrive academically
                  and personally.
                </p>
                <div className="bg-blue-50 p-6 rounded-lg border border-blue-100" data-id="element-1492">
                  <h4 className="font-bold text-blue-900 mb-3" data-id="element-1493">
                    Our Staff Qualifications
                  </h4>
                  <ul className="space-y-2 text-gray-700" data-id="element-1494">
                    <li className="flex items-start" data-id="element-1495">
                      <span className="text-yellow-500 mr-2" data-id="element-1496">•</span>
                      <span data-id="element-1497">
                        100% of teachers hold at least a Bachelor's degree in
                        their subject area
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-1498">
                      <span className="text-yellow-500 mr-2" data-id="element-1499">•</span>
                      <span data-id="element-1500">
                        40% hold Master's degrees or higher qualifications
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-1501">
                      <span className="text-yellow-500 mr-2" data-id="element-1502">•</span>
                      <span data-id="element-1503">
                        All teachers are registered with the Teachers
                        Registration Council of Nigeria (TRCN)
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-1504">
                      <span className="text-yellow-500 mr-2" data-id="element-1505">•</span>
                      <span data-id="element-1506">
                        Regular training in modern pedagogical approaches
                        including PSI/PMI methodology
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div data-id="element-1507">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kCtjXZxCNmomG25TYhbjrQ/WhatsApp_Image_2025-11-07_at_10.21.13.jpg" alt="Junior School Staff in Session" className="w-full h-auto rounded-lg shadow-lg" data-id="element-1508" />
                <p className="text-center text-sm text-gray-600 mt-3" data-id="element-1509">
                  Our dedicated Junior School staff during a professional
                  development session
                </p>
              </div>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg border border-blue-100 mb-8" data-id="element-1510">
              <div className="text-center mb-6" data-id="element-1511">
                <h3 className="text-2xl font-bold text-blue-900" data-id="element-1512">
                  Faculty Profile
                </h3>
                <p className="text-gray-700 mt-2" data-id="element-1513">
                  Our teaching staff consists of 45 full-time teachers with
                  diverse qualifications and experience.
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1514">
                <div data-id="element-1515">
                  <h4 className="font-bold text-blue-900 mb-3" data-id="element-1516">
                    Qualifications
                  </h4>
                  <div className="relative h-60" data-id="element-1517">
                    <div className="absolute bottom-0 left-0 w-full h-full flex items-end" data-id="element-1518">
                      <div className="w-1/3 h-[35%] bg-blue-700 mx-1 relative group" data-id="element-1519">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1520">
                          35%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1521">
                          Bachelor's
                        </div>
                      </div>
                      <div className="w-1/3 h-[55%] bg-blue-700 mx-1 relative group" data-id="element-1522">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1523">
                          55%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1524">
                          Master's
                        </div>
                      </div>
                      <div className="w-1/3 h-[10%] bg-blue-700 mx-1 relative group" data-id="element-1525">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1526">
                          10%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1527">
                          PhD
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-1528">
                  <h4 className="font-bold text-blue-900 mb-3" data-id="element-1529">
                    Teaching Experience
                  </h4>
                  <div className="relative h-60" data-id="element-1530">
                    <div className="absolute bottom-0 left-0 w-full h-full flex items-end" data-id="element-1531">
                      <div className="w-1/4 h-[15%] bg-blue-700 mx-1 relative group" data-id="element-1532">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1533">
                          15%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1534">
                          0-5 yrs
                        </div>
                      </div>
                      <div className="w-1/4 h-[35%] bg-blue-700 mx-1 relative group" data-id="element-1535">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1536">
                          35%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1537">
                          6-10 yrs
                        </div>
                      </div>
                      <div className="w-1/4 h-[30%] bg-blue-700 mx-1 relative group" data-id="element-1538">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1539">
                          30%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1540">
                          11-15 yrs
                        </div>
                      </div>
                      <div className="w-1/4 h-[20%] bg-blue-700 mx-1 relative group" data-id="element-1541">
                        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-blue-900 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1542">
                          20%
                        </div>
                        <div className="absolute bottom-0 left-0 w-full text-center text-xs font-medium py-1" data-id="element-1543">
                          16+ yrs
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-1544">
                  <h4 className="font-bold text-blue-900 mb-3" data-id="element-1545">
                    Subject Distribution
                  </h4>
                  <ul className="space-y-2" data-id="element-1546">
                    <li className="flex items-center" data-id="element-1547">
                      <div className="w-24 bg-gray-200 h-4 rounded-full mr-3" data-id="element-1548">
                        <div className="bg-blue-700 h-4 rounded-full" style={{
                        width: '25%'
                      }} data-id="element-1549"></div>
                      </div>
                      <span className="text-sm" data-id="element-1550">Languages (25%)</span>
                    </li>
                    <li className="flex items-center" data-id="element-1551">
                      <div className="w-24 bg-gray-200 h-4 rounded-full mr-3" data-id="element-1552">
                        <div className="bg-blue-700 h-4 rounded-full" style={{
                        width: '20%'
                      }} data-id="element-1553"></div>
                      </div>
                      <span className="text-sm" data-id="element-1554">Sciences (20%)</span>
                    </li>
                    <li className="flex items-center" data-id="element-1555">
                      <div className="w-24 bg-gray-200 h-4 rounded-full mr-3" data-id="element-1556">
                        <div className="bg-blue-700 h-4 rounded-full" style={{
                        width: '15%'
                      }} data-id="element-1557"></div>
                      </div>
                      <span className="text-sm" data-id="element-1558">Mathematics (15%)</span>
                    </li>
                    <li className="flex items-center" data-id="element-1559">
                      <div className="w-24 bg-gray-200 h-4 rounded-full mr-3" data-id="element-1560">
                        <div className="bg-blue-700 h-4 rounded-full" style={{
                        width: '15%'
                      }} data-id="element-1561"></div>
                      </div>
                      <span className="text-sm" data-id="element-1562">Social Sciences (15%)</span>
                    </li>
                    <li className="flex items-center" data-id="element-1563">
                      <div className="w-24 bg-gray-200 h-4 rounded-full mr-3" data-id="element-1564">
                        <div className="bg-blue-700 h-4 rounded-full" style={{
                        width: '10%'
                      }} data-id="element-1565"></div>
                      </div>
                      <span className="text-sm" data-id="element-1566">Business Studies (10%)</span>
                    </li>
                    <li className="flex items-center" data-id="element-1567">
                      <div className="w-24 bg-gray-200 h-4 rounded-full mr-3" data-id="element-1568">
                        <div className="bg-blue-700 h-4 rounded-full" style={{
                        width: '15%'
                      }} data-id="element-1569"></div>
                      </div>
                      <span className="text-sm" data-id="element-1570">Others (15%)</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="text-center" data-id="element-1571">
              <Button href="/academics/faculty" variant="outline" data-id="element-1572">
                Meet Our Full Teaching Staff
              </Button>
            </div>
          </div>
        </section>
        {/* Academic Calendar Section */}
        <section className="mb-16" id="calendar" data-id="element-1573">
          <div className="text-center mb-10" data-id="element-1574">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1575">
              Academic Calendar
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1576"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1577">
              Important dates and events for the 2023/2024 academic year.
            </p>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-1578">
            <div className="bg-blue-900 text-white p-4" data-id="element-1579">
              <h3 className="text-xl font-bold" data-id="element-1580">2023/2024 Academic Calendar</h3>
            </div>
            <div className="p-6" data-id="element-1581">
              <Accordion variant="bordered" data-id="element-1582">
                <AccordionItem title="First Term (September - December 2023)" defaultOpen data-id="element-1583">
                  <div className="overflow-x-auto" data-id="element-1584">
                    <table className="min-w-full bg-white" data-id="element-1585">
                      <thead data-id="element-1586">
                        <tr className="bg-blue-100" data-id="element-1587">
                          <th className="py-2 px-4 text-left" data-id="element-1588">Date</th>
                          <th className="py-2 px-4 text-left" data-id="element-1589">Event</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200" data-id="element-1590">
                        <tr data-id="element-1591">
                          <td className="py-2 px-4 font-medium" data-id="element-1592">
                            September 10, 2023
                          </td>
                          <td className="py-2 px-4" data-id="element-1593">
                            Boarding Students Return
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1594">
                          <td className="py-2 px-4 font-medium" data-id="element-1595">
                            September 11, 2023
                          </td>
                          <td className="py-2 px-4" data-id="element-1596">
                            First Term Begins / Classes Resume
                          </td>
                        </tr>
                        <tr data-id="element-1597">
                          <td className="py-2 px-4 font-medium" data-id="element-1598">
                            October 1, 2023
                          </td>
                          <td className="py-2 px-4" data-id="element-1599">
                            Independence Day (Public Holiday)
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1600">
                          <td className="py-2 px-4 font-medium" data-id="element-1601">
                            October 16-20, 2023
                          </td>
                          <td className="py-2 px-4" data-id="element-1602">Mid-Term Examinations</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1603">
                          <td className="py-2 px-4 font-medium" data-id="element-1604">
                            October 21-24, 2023
                          </td>
                          <td className="py-2 px-4" data-id="element-1605">Mid-Term Break</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1606">
                          <td className="py-2 px-4 font-medium" data-id="element-1607">
                            November 10, 2023
                          </td>
                          <td className="py-2 px-4" data-id="element-1608">
                            Inter-House Sports Competition
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1609">
                          <td className="py-2 px-4 font-medium" data-id="element-1610">
                            December 4-15, 2023
                          </td>
                          <td className="py-2 px-4" data-id="element-1611">First Term Examinations</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1612">
                          <td className="py-2 px-4 font-medium" data-id="element-1613">
                            December 15, 2023
                          </td>
                          <td className="py-2 px-4" data-id="element-1614">
                            End of First Term / Christmas Carol
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1615">
                          <td className="py-2 px-4 font-medium" data-id="element-1616">
                            December 16, 2023
                          </td>
                          <td className="py-2 px-4" data-id="element-1617">Students Vacation</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </AccordionItem>
                <AccordionItem title="Second Term (January - April 2024)" data-id="element-1618">
                  <div className="overflow-x-auto" data-id="element-1619">
                    <table className="min-w-full bg-white" data-id="element-1620">
                      <thead data-id="element-1621">
                        <tr className="bg-blue-100" data-id="element-1622">
                          <th className="py-2 px-4 text-left" data-id="element-1623">Date</th>
                          <th className="py-2 px-4 text-left" data-id="element-1624">Event</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200" data-id="element-1625">
                        <tr data-id="element-1626">
                          <td className="py-2 px-4 font-medium" data-id="element-1627">
                            January 7, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1628">
                            Boarding Students Return
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1629">
                          <td className="py-2 px-4 font-medium" data-id="element-1630">
                            January 8, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1631">
                            Second Term Begins / Classes Resume
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1632">
                          <td className="py-2 px-4 font-medium" data-id="element-1633">
                            February 15, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1634">
                            Founders' Day Celebration
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1635">
                          <td className="py-2 px-4 font-medium" data-id="element-1636">
                            February 19-23, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1637">Mid-Term Examinations</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1638">
                          <td className="py-2 px-4 font-medium" data-id="element-1639">
                            February 24-27, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1640">Mid-Term Break</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1641">
                          <td className="py-2 px-4 font-medium" data-id="element-1642">
                            March 15, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1643">Career Day</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1644">
                          <td className="py-2 px-4 font-medium" data-id="element-1645">
                            April 1-12, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1646">
                            Second Term Examinations
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1647">
                          <td className="py-2 px-4 font-medium" data-id="element-1648">
                            April 12, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1649">End of Second Term</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1650">
                          <td className="py-2 px-4 font-medium" data-id="element-1651">
                            April 13, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1652">Students Vacation</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </AccordionItem>
                <AccordionItem title="Third Term (April - July 2024)" data-id="element-1653">
                  <div className="overflow-x-auto" data-id="element-1654">
                    <table className="min-w-full bg-white" data-id="element-1655">
                      <thead data-id="element-1656">
                        <tr className="bg-blue-100" data-id="element-1657">
                          <th className="py-2 px-4 text-left" data-id="element-1658">Date</th>
                          <th className="py-2 px-4 text-left" data-id="element-1659">Event</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200" data-id="element-1660">
                        <tr className="bg-gray-50" data-id="element-1661">
                          <td className="py-2 px-4 font-medium" data-id="element-1662">
                            April 28, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1663">
                            Boarding Students Return
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1664">
                          <td className="py-2 px-4 font-medium" data-id="element-1665">
                            April 29, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1666">
                            Third Term Begins / Classes Resume
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1667">
                          <td className="py-2 px-4 font-medium" data-id="element-1668">May 1, 2024</td>
                          <td className="py-2 px-4" data-id="element-1669">
                            Workers' Day (Public Holiday)
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1670">
                          <td className="py-2 px-4 font-medium" data-id="element-1671">
                            May 20-24, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1672">
                            WAEC/NECO Examinations Begin (SS3)
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1673">
                          <td className="py-2 px-4 font-medium" data-id="element-1674">
                            June 3-7, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1675">Mid-Term Examinations</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1676">
                          <td className="py-2 px-4 font-medium" data-id="element-1677">
                            June 8-11, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1678">Mid-Term Break</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1679">
                          <td className="py-2 px-4 font-medium" data-id="element-1680">
                            July 1-12, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1681">Third Term Examinations</td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1682">
                          <td className="py-2 px-4 font-medium" data-id="element-1683">
                            July 19, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1684">
                            Speech & Prize-Giving Day
                          </td>
                        </tr>
                        <tr className="bg-gray-50" data-id="element-1685">
                          <td className="py-2 px-4 font-medium" data-id="element-1686">
                            July 20, 2024
                          </td>
                          <td className="py-2 px-4" data-id="element-1687">
                            End of Academic Year / Students Vacation
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </AccordionItem>
              </Accordion>
              <div className="mt-6 bg-yellow-50 p-4 rounded-lg border border-yellow-100" data-id="element-1688">
                <div className="flex items-start" data-id="element-1689">
                  <CalendarIcon className="h-5 w-5 text-yellow-600 mt-0.5 mr-2" data-id="element-1690" />
                  <div data-id="element-1691">
                    <p className="font-bold text-blue-900" data-id="element-1692">Important Note:</p>
                    <p className="text-gray-700 text-sm" data-id="element-1693">
                      Dates are subject to change. Parents and students will be
                      notified of any adjustments to the academic calendar
                      through official communication channels.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Clubs & Societies Section */}
        <section id="clubs" data-id="element-1694">
          <div className="text-center mb-10" data-id="element-1695">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-1696">
              Clubs & Societies
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-1697"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-1698">
              Explore the various extracurricular activities that enhance our
              academic program and develop students' talents and interests.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1699">
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-1700">
              <div className="flex items-center mb-4" data-id="element-1701">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-1702">
                  <BeakerIcon className="h-6 w-6 text-blue-700" data-id="element-1703" />
                </div>
                <h3 className="text-lg font-bold text-blue-900" data-id="element-1704">
                  Science Club
                </h3>
              </div>
              <p className="text-gray-700 mb-3" data-id="element-1705">
                For students passionate about science and technology. Activities
                include experiments, robotics, coding, and preparation for
                science competitions.
              </p>
              <div className="text-sm text-gray-600" data-id="element-1706">
                <span className="font-medium" data-id="element-1707">Meeting Day:</span> Tuesdays
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-1708">
              <div className="flex items-center mb-4" data-id="element-1709">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-1710">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1711">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 001 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" data-id="element-1712" />
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-blue-900" data-id="element-1713">
                  Debate Society
                </h3>
              </div>
              <p className="text-gray-700 mb-3" data-id="element-1714">
                Focuses on developing public speaking, critical thinking, and
                argumentation skills. Members participate in debates, public
                speaking contests, and model UN conferences.
              </p>
              <div className="text-sm text-gray-600" data-id="element-1715">
                <span className="font-medium" data-id="element-1716">Meeting Day:</span> Wednesdays
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-1717">
              <div className="flex items-center mb-4" data-id="element-1718">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-1719">
                  <PenToolIcon className="h-6 w-6 text-blue-700" data-id="element-1720" />
                </div>
                <h3 className="text-lg font-bold text-blue-900" data-id="element-1721">
                  Art & Photography Club
                </h3>
              </div>
              <p className="text-gray-700 mb-3" data-id="element-1722">
                For creative students interested in visual arts. Activities
                include drawing, painting, sculpture, photography, and
                organizing art exhibitions.
              </p>
              <div className="text-sm text-gray-600" data-id="element-1723">
                <span className="font-medium" data-id="element-1724">Meeting Day:</span> Thursdays
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-1725">
              <div className="flex items-center mb-4" data-id="element-1726">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-1727">
                  <MusicIcon className="h-6 w-6 text-blue-700" data-id="element-1728" />
                </div>
                <h3 className="text-lg font-bold text-blue-900" data-id="element-1729">
                  Music & Drama Club
                </h3>
              </div>
              <p className="text-gray-700 mb-3" data-id="element-1730">
                For students interested in performing arts. Members learn to
                play instruments, sing, act, and participate in school
                productions and competitions.
              </p>
              <div className="text-sm text-gray-600" data-id="element-1731">
                <span className="font-medium" data-id="element-1732">Meeting Day:</span> Fridays
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-1733">
              <div className="flex items-center mb-4" data-id="element-1734">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-1735">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1736">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" data-id="element-1737" />
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-blue-900" data-id="element-1738">
                  Environmental Club
                </h3>
              </div>
              <p className="text-gray-700 mb-3" data-id="element-1739">
                Focuses on environmental conservation and sustainability.
                Activities include tree planting, recycling initiatives, and
                awareness campaigns.
              </p>
              <div className="text-sm text-gray-600" data-id="element-1740">
                <span className="font-medium" data-id="element-1741">Meeting Day:</span> Mondays
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-1742">
              <div className="flex items-center mb-4" data-id="element-1743">
                <div className="p-3 bg-blue-100 rounded-full mr-3" data-id="element-1744">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1745">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 001 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" data-id="element-1746" />
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-blue-900" data-id="element-1747">
                  Robotics Club
                </h3>
              </div>
              <p className="text-gray-700 mb-3" data-id="element-1748">
                For students interested in robotics and engineering. Members
                learn to design, build, and program robots, and participate in
                robotics competitions.
              </p>
              <div className="text-sm text-gray-600" data-id="element-1749">
                <span className="font-medium" data-id="element-1750">Meeting Day:</span> Tuesdays
              </div>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-1751">
            <Button href="/student-life/clubs" variant="primary" className="mx-auto" data-id="element-1752">
              Explore All Clubs & Societies
            </Button>
          </div>
        </section>
      </div>
    </div>;
};
export default Academics;